module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "hello"
  }, [_h('h1', [_s(helloPopupMessage)]), " ", _h('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": this.begin
    }
  }, [_s(letsBeginMessage)])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3736aefa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/Hello.vue
 ** module id = 28
 ** module chunks = 1
 **/